import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propBool, propFunc, propShape, propStr, } from '../../../helpers/custom-prop-types';
import SlideSearchUpdateNameAndPositionForm from '../../Ui/SlideSearch/Form/SlideSearchUpdateNameAndPositionForm';
import SlideSearchRegistrationModal from '../../Ui/SlideSearch/Modal/SlideSearchRegistrationModal';
import SlideSearchTutorialModal from '../Common/Modal/SlideSearchTutorialModal';
const SlideSearchTopTutorialModals = (props) => {
    const { finishOnBoarding, isFree, isRequiredProfileUpdate, isShow, isShowSearchFirstView, kanaRef, onSubmitOnlyNameAndPositionRegistration, userMode, } = props;
    // 氏名未入力の場合、氏名入力モーダルを優先表示する
    const isShowRegistrationModal = isShow && isRequiredProfileUpdate;
    // 氏名未入力でない、かつチュートリアル未経験であればチュートリアル表示モーダルを表示する
    const isShowTutorialModal = isShow && !isRequiredProfileUpdate && isShowSearchFirstView;
    return (_jsxs(_Fragment, { children: [_jsx(SlideSearchRegistrationModal, { formComponent: _jsx(SlideSearchUpdateNameAndPositionForm, { kanaRef: kanaRef, userMode: userMode }), isShow: isShowRegistrationModal, onSubmit: onSubmitOnlyNameAndPositionRegistration }), _jsx(SlideSearchTutorialModal, { hideModal: finishOnBoarding, isFree: isFree, isShow: isShowTutorialModal })] }));
};
SlideSearchTopTutorialModals.propTypes = {
    finishOnBoarding: propFunc().isRequired,
    isFree: propBool().isRequired,
    isRequiredProfileUpdate: propBool().isRequired,
    isShow: propBool().isRequired,
    isShowSearchFirstView: propBool().isRequired,
    kanaRef: propShape().isRequired,
    onSubmitOnlyNameAndPositionRegistration: propFunc().isRequired,
    userMode: propStr().isRequired,
};
export default SlideSearchTopTutorialModals;
